var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center data-info",class:{ 'data-info--border-0': _vm.border0 },style:({
    paddingTop: `${_vm.paddingTop}px`,
    paddingBottom: `${_vm.paddingBottom}px`,
  })},[_c('a-icon',{attrs:{"type":"info-circle"}}),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }